import { addYears, endOfDay, endOfYear, isSameDay } from "date-fns/esm";
import { subDays } from 'date-fns/esm/fp';
import { startOfYear } from "date-fns/fp";
import { enGB } from "date-fns/locale";
import { useEffect, useState, useRef } from "react";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { AiFillCalendar } from "react-icons/ai";
import HelperService from "../../Services/HelperService";
import './FXDateRangePicker.css';
import { startOfMonth, startOfWeek, startOfDay } from "date-fns";

interface PropData {
  date_range: any;
  selectData: any
  color?: string
  id?: any
}

const FXDateRangePicker = (props: PropData) => {
  const today = new Date();
  const [showPicker, setShowPicker] = useState(false);
  const clickedPresetRef = useRef<string | null>(null);
  const [lastSelectedPreset, setLastSelectedPreset] = useState<string | null>(null);
  const [state, setState] = useState([
    {
      startDate: subDays(30, new Date()),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const getDateChangeEvent = (ranges: any) => {
    setState([{
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: 'selection'
    }])

    if (clickedPresetRef.current) {
      setLastSelectedPreset(clickedPresetRef.current);
      clickedPresetRef.current = null;
    } else {
      setLastSelectedPreset(null);
    }

    if (ranges.selection.startDate !== ranges.selection.endDate) {
      var dataRange = {
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: 'selection'
      };
      setShowPicker(false)
      props.selectData(dataRange);
    }
  }

  const customStaticRanges = [
    {
      label: "Today",
      range: () => {
        clickedPresetRef.current = "Today";
        return {
          startDate: startOfDay(today),
          endDate: endOfDay(today)
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "Today";
        return (
          isSameDay(range.startDate, today) &&
          isSameDay(range.endDate, today)
        );
      }
    },
    {
      label: "Last Week",
      range: () => {
        clickedPresetRef.current = "Last Week";
        return {
          startDate: startOfWeek(subDays(7, today), { weekStartsOn: 1 }),
          endDate: endOfDay(subDays(1, startOfWeek(today, { weekStartsOn: 1 })))
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "Last Week";
        return (
          isSameDay(range.startDate, startOfWeek(subDays(7, today), { weekStartsOn: 1 })) &&
          isSameDay(range.endDate, subDays(1, startOfWeek(today, { weekStartsOn: 1 })))
        );
      }
    },
    {
      label: "Last Month",
      range: () => {
        clickedPresetRef.current = "Last Month";
        const prevMonthEnd = subDays(1, startOfMonth(today));
        return {
          startDate: startOfMonth(prevMonthEnd),
          endDate: endOfDay(prevMonthEnd)
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "Last Month";
        const prevMonthEnd = subDays(1, startOfMonth(today));
        return (
          isSameDay(range.startDate, startOfMonth(prevMonthEnd)) &&
          isSameDay(range.endDate, prevMonthEnd)
        );
      }
    },
    {
      label: "This Week",
      range: () => {
        clickedPresetRef.current = "This Week";
        return {
          startDate: startOfWeek(today, { weekStartsOn: 1 }),
          endDate: today
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "This Week";
        return (
          !isSameDay(range.startDate, range.endDate) &&
          isSameDay(range.startDate, startOfWeek(today, { weekStartsOn: 1 })) &&
          isSameDay(range.endDate, today)
        );
      }
    },
    {
      label: "This Month",
      range: () => {
        clickedPresetRef.current = "This Month";
        return {
          startDate: startOfMonth(today),
          endDate: today
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "This Month";
        return (
          !isSameDay(range.startDate, range.endDate) &&
          isSameDay(range.startDate, startOfMonth(today)) &&
          isSameDay(range.endDate, today)
        );
      }
    },
    {
      label: "Last 2 Months",
      range: () => {
        clickedPresetRef.current = "Last 2 Months";
        return {
          startDate: subDays(60, today),
          endDate: endOfDay(today)
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "Last 2 Months";
        return (
          isSameDay(range.startDate, subDays(60, today)) &&
          isSameDay(range.endDate, today)
        );
      }
    },
    {
      label: "This year",
      range: () => {
        clickedPresetRef.current = "This year";
        return {
          startDate: startOfYear(today),
          endDate: endOfDay(today)
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "This year";
        return (
          isSameDay(range.startDate, startOfYear(today)) &&
          isSameDay(range.endDate, today)
        );
      }
    },
    {
      label: "Last year",
      range: () => {
        clickedPresetRef.current = "Last year";
        return {
          startDate: startOfYear(addYears(today, -1)),
          endDate: endOfYear(addYears(today, -1))
        };
      },
      isSelected(range: any) {
        if (lastSelectedPreset) return lastSelectedPreset === "Last year";
        return (
          isSameDay(range.startDate, startOfYear(addYears(today, -1))) &&
          isSameDay(range.endDate, endOfYear(addYears(today, -1)))
        );
      }
    }
  ];

  useEffect(() => {
    document.addEventListener('mouseup', function (e: any) {
      var container = document.getElementById(`wbDateRangPicker${props.id ? props.id : ""}`);
      if (!container?.contains(e.target)) {
        setShowPicker(false);
      }
    }.bind(this));
  }, [])


  useEffect(() => {
    if (props?.date_range?.startDate) {
      var newDateRange = {
        startDate: new Date(props.date_range.startDate ? props.date_range.startDate : ''),
        endDate: new Date(props.date_range.endDate ? props.date_range.endDate : ''),
        key: 'selection'
      }
      setState([newDateRange]);
    } else {
      setLastSelectedPreset(null);
    }
  }, [props.date_range])
  return (
    //  minWidth: "203px",
    <div className="form-control form-control-sm d-flex align-items-center" id={`wbDateRangPicker${props.id ? props.id : ""}`} style={{ textAlign: "center" }}>
      {showPicker ? <> <p className={'mb-0 font-12  mClass ' + (props.color !== "" ? props.color : "text-black")} onClick={() => { setShowPicker(true) }}><AiFillCalendar size={16} className="icon" />{" "}{HelperService.getFormatedDateForDetail(state[0].startDate, "MMM D, YYYY")} - {HelperService.getFormatedDateForDetail(state[0].endDate, "MMM D, YYYY")}</p>
        <DateRangePicker
          onChange={getDateChangeEvent}
          months={1}
          ranges={state}
          direction="vertical"
          showPreview={true}
          dragSelectionEnabled={true}
          maxDate={new Date()}
          rangeColors={["#DAAF51"]}
          color={"#FFF"}
          locale={enGB}
          staticRanges={customStaticRanges}
        /></> : <>
        <p className={'mb-0 font-12 dashboard-date-range  mClass ' + (props.color !== "" ? props.color : "text-black")} onClick={() => { setShowPicker(true) }}><AiFillCalendar size={16} className="icon" />{" "}{HelperService.getFormatedDateForDetail(state[0].startDate, "MMM D, YYYY")} - {HelperService.getFormatedDateForDetail(state[0].endDate, "MMM D, YYYY")}</p></>}

    </div>
  );
};

export default FXDateRangePicker;
